import React from 'react';
import EmployeeNavigation from 'main/containers/employees/navigation';
import {auth} from 'main/tools';
import BrokerEmployeeProfileSubnav from './BrokerEmployeeProfileSubnav';
import EmployeeProfileSubnav from './EmployeeProfileSubnav';
import {DocumentTitle} from 'main/components';

const EmployeeProfileHeader = ({uiState}) => {
  const {employee} = uiState;

  return (
    <div className='Subnav Subnav--react'>
      <DocumentTitle title={employee.name}/>
      <div className='Container'>
        <div className='py3'>
          <div className='clearfix'>
            <div className='col col-12 sm-col-8'>
              <div className='table-cell align-middle'>
                <EmployeeNavigation currentEmployee={employee}/>
              </div>
            </div>
          </div>
        </div>
        {auth.company.enrolmentOnly
          ? <BrokerEmployeeProfileSubnav uiState={uiState}/>
          : <EmployeeProfileSubnav uiState={uiState}/>
        }
      </div>
    </div>
  );
};

export default EmployeeProfileHeader;
